// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2ZYiu","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__25q25"};